import { getDecodedToken } from '@webclient/lib/jwt';

import {
  UserSettingsType,
  UserSpecificSettingsType,
} from '@webclient/shared-types/auth';

export default function initializeUserSpecificSettingsAfterJWTTokenIsSet(
  fallbackSettigs: UserSettingsType,
) {
  const token = getDecodedToken(localStorage.getItem('token'));
  if (!token) return;

  const uuid = token.uuid;
  const existingSettings = JSON.parse(
    localStorage.getItem('userSpecificSettings') || 'null',
  ) as UserSpecificSettingsType;

  const newSettings: UserSpecificSettingsType = {
    ...existingSettings,
    [uuid]: {
      ...fallbackSettigs,
      ...existingSettings?.[uuid],
      bot: {
        ...fallbackSettigs.bot,
        ...existingSettings?.[uuid]?.bot,
      },
      voice: {
        ...fallbackSettigs.voice,
        ...existingSettings?.[uuid]?.voice,
      },
      customStyle: {
        ...fallbackSettigs.customStyle,
        ...existingSettings?.[uuid]?.customStyle,
      },
    },
  };

  localStorage.setItem('userSpecificSettings', JSON.stringify(newSettings));

  return newSettings;
}
